import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, AlertTriangle } from "lucide-react";
import DropZone from "../components/DropZone";

function resolveSrc(u) { if (!u) return ""; if (u.startsWith("http")) return u; if (u.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`; return u; }

const DEFAULTS = {
  hero_title: "", hero_subtitle: "", success_title: "",
  google_maps_embed: "",
  facade_image_1: "", facade_caption_1: "",
  facade_image_2: "", facade_caption_2: "",
};

export default function ContactExtrasEditor() {
  const [data, setData] = useState(DEFAULTS);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/contact_extras").then(({ data: v }) => v && setData({ ...DEFAULTS, ...v }));
  }, []);

  const upd = (k, v) => setData((s) => ({ ...s, [k]: v }));

  const save = async () => {
    setSaving(true);
    try { await api.put("/content/kv/contact_extras", { value: data }); toast.success("Página de contato atualizada."); }
    catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div>
          <h1 className="font-display text-4xl">Contato — Mapa & Fachada</h1>
          <p className="text-sm text-neutral-500 mt-1">Aparecem abaixo do formulário na página /contato.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="contact-extras-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
      </div>

      <section className="border border-black/10 p-5 rounded mb-6">
        <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700 mb-3">Cabeçalhos da página</div>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-neutral-500">Título do hero</label>
            <input value={data.hero_title} onChange={(e) => upd("hero_title", e.target.value)} data-testid="contact-hero-title-input"
              placeholder='Ex: "Venha tomar um café."'
              className="w-full border border-black/15 px-3 py-2 rounded text-sm" />
          </div>
          <div>
            <label className="text-xs text-neutral-500">Subtítulo do hero</label>
            <input value={data.hero_subtitle} onChange={(e) => upd("hero_subtitle", e.target.value)} data-testid="contact-hero-subtitle-input"
              placeholder="Ex: Vamos tornar o seu produto imobiliário..."
              className="w-full border border-black/15 px-3 py-2 rounded text-sm" />
          </div>
          <div className="md:col-span-2">
            <label className="text-xs text-neutral-500">Título da seção "Sede" (acima do mapa)</label>
            <input value={data.success_title} onChange={(e) => upd("success_title", e.target.value)} data-testid="contact-success-title-input"
              placeholder='Ex: "Te esperamos para um café."'
              className="w-full border border-black/15 px-3 py-2 rounded text-sm" />
          </div>
        </div>
        <p className="text-[11px] text-neutral-400 mt-2">Deixe vazio para usar os textos padrão em cada idioma.</p>
      </section>

      <section className="border border-black/10 p-5 rounded mb-6">
        <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700 mb-3">Google Maps</div>
        <div className="text-xs text-neutral-500 mb-2 flex items-start gap-2">
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-amber-600" />
          <span>No Google Maps: clique em "Compartilhar" → "Incorporar um mapa" → copie APENAS o atributo <code className="bg-black/5 px-1">src</code> (URL que começa com <code className="bg-black/5 px-1">https://www.google.com/maps/embed?...</code>).</span>
        </div>
        <textarea value={data.google_maps_embed} onChange={(e) => upd("google_maps_embed", e.target.value)} rows={3} className="w-full border border-black/15 px-3 py-2 rounded text-xs font-mono" placeholder="https://www.google.com/maps/embed?pb=..." data-testid="contact-map-url" />
        {data.google_maps_embed && (
          <div className="mt-3 aspect-[16/9] border border-black/10 rounded overflow-hidden">
            <iframe src={data.google_maps_embed} title="Preview" className="w-full h-full" loading="lazy" />
          </div>
        )}
      </section>

      <section className="grid md:grid-cols-2 gap-4">
        {[1, 2].map((n) => (
          <div key={n} className="border border-black/10 p-5 rounded">
            <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700 mb-3">Imagem da Fachada {n}</div>
            {data[`facade_image_${n}`] && <img src={resolveSrc(data[`facade_image_${n}`])} alt="" className="w-full aspect-[16/10] object-cover rounded mb-3" />}
            <DropZone multiple={false} onUploaded={(f) => upd(`facade_image_${n}`, f.url)} />
            <input value={data[`facade_image_${n}`] || ""} onChange={(e) => upd(`facade_image_${n}`, e.target.value)} placeholder="ou URL" className="w-full text-xs border border-black/15 px-2 py-1.5 rounded mt-2" data-testid={`facade-url-${n}`} />
            <label className="text-xs text-neutral-500 mt-3 block">Legenda</label>
            <input value={data[`facade_caption_${n}`] || ""} onChange={(e) => upd(`facade_caption_${n}`, e.target.value)} className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" placeholder="Sede Places · Goiânia" data-testid={`facade-caption-${n}`} />
          </div>
        ))}
      </section>
    </div>
  );
}
